import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import Loading from 'react-loading';
import { isFeatureEnabled } from '../../hooks/useFeatureFlag';
import regionConfig from '../../config/regionConfig';
import { formatPriceWithSymbol } from '../../utils/currency';

import styled, { keyframes } from "styled-components";

import './styles.css';
import { formatDateTz, nowTz, toTz } from '../../utils/timezone';
import { useFormik } from "formik";
import * as Yup from "yup";
//import creditCardType from 'credit-card-type';

import InputMask from 'react-input-mask'
import axios from 'axios';
import {
    getEmpresa,
    getDaysToExpireLicense,
    searchClienteAsaasAndGetInvoice,
    listarAssinaturasAsaas,
    getDataCustomerAsaas,
    verificarLicencaLocal,
    verificarLicencaAsaas,
    getPlansAsaas
} from "../../services/api";
import { SidebarContext } from "../../AppRoutes";
import { RiErrorWarningLine } from "react-icons/ri";
import { MdPix } from "react-icons/md";
import { FaBarcode } from "react-icons/fa6";
import { IoIosCard } from "react-icons/io";
import { toast } from "react-toastify";

import { getStoredUser } from '../../utils/safeStorage';
import Modal from "react-modal";
import { FaMoneyBillWave, FaCheckCircle, FaTimesCircle, FaUser, FaEnvelope, FaCrown, FaSync, FaExternalLinkAlt, FaSpinner, FaFileInvoiceDollar, FaCalendarAlt, FaReceipt, FaTimes, FaClock, FaHeadset } from "react-icons/fa";


const Teste = styled.div`
  display: flex;
  margin-left:  ${({ sidebar }) => (sidebar ? '250px' : '100px')};
  height:auto;
  width:auto;
  transition: 150ms;
  background-color:rgb(255,255,255)!important;
  --background-color:white!important;
  overflow: initial;
  z-Index: 9;

  @media (max-width: 880px) {
        margin-left: 0;
    }
`;

// =============================================
// STYLED COMPONENTS PARA LOADING E ASSINATURA
// =============================================

const spinAnimation = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const pulseAnimation = keyframes`
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
`;

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    gap: 20px;

    .spinner-wrapper {
        position: relative;
        width: 80px;
        height: 80px;

        .spinner-ring {
            position: absolute;
            width: 100%;
            height: 100%;
            border: 4px solid #e8e8e8;
            border-top: 4px solid #318cd5;
            border-radius: 50%;
            animation: ${spinAnimation} 1s linear infinite;
        }

        .spinner-ring-inner {
            position: absolute;
            top: 10px;
            left: 10px;
            width: calc(100% - 20px);
            height: calc(100% - 20px);
            border: 3px solid #e8e8e8;
            border-bottom: 3px solid #4facfe;
            border-radius: 50%;
            animation: ${spinAnimation} 0.8s linear infinite reverse;
        }

        .spinner-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 24px;
            color: #318cd5;
        }
    }

    .loading-text {
        font-size: 16px;
        color: #666;
        font-weight: 500;
        animation: ${pulseAnimation} 1.5s ease-in-out infinite;
    }
`;

const SubscriptionCard = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-bottom: 24px;
`;

const SubscriptionHeader = styled.div`
    background: linear-gradient(135deg, #318cd5, #4facfe);
    padding: 24px;
    color: white;

    .header-content {
        display: flex;
        align-items: center;
        gap: 16px;

        .icon-box {
            width: 56px;
            height: 56px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                font-size: 26px;
            }
        }

        .header-text {
            h2 {
                margin: 0 0 4px 0;
                font-size: 22px;
                font-weight: 600;
            }

            p {
                margin: 0;
                opacity: 0.9;
                font-size: 14px;
            }
        }
    }
`;

const SubscriptionBody = styled.div`
    padding: 24px;
`;

const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
`;

const InfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.2s ease;
    min-width: 0;
    overflow: hidden;

    &:hover {
        background: #f0f4f8;
    }

    .info-icon {
        width: 44px;
        height: 44px;
        background: ${({ $iconBg }) => $iconBg || 'linear-gradient(135deg, #318cd5, #4facfe)'};
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
            font-size: 20px;
            color: white;
        }
    }

    .info-content {
        flex: 1;
        min-width: 0;

        .info-label {
            font-size: 12px;
            color: #666;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 4px;
        }

        .info-value {
            font-size: 15px;
            color: #1a1a2e;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            word-break: break-word;
            overflow-wrap: break-word;
        }
    }
`;

const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    background: ${({ $status }) => {
        if ($status === 'active' || $status === 'valid') return '#e8f5e9';
        if ($status === 'pending') return '#fff3e0';
        return '#ffebee';
    }};
    color: ${({ $status }) => {
        if ($status === 'active' || $status === 'valid') return '#2e7d32';
        if ($status === 'pending') return '#e65100';
        return '#c62828';
    }};

    svg {
        font-size: 14px;
    }
`;

const InvoiceCard = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
`;

const InvoiceHeader = styled.div`
    background: linear-gradient(135deg, #318cd5, #4facfe);
    padding: 20px 24px;
    color: white;
    display: flex;
    align-items: center;
    gap: 14px;

    .invoice-icon {
        width: 48px;
        height: 48px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            font-size: 22px;
        }
    }

    h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
    }
`;

const InvoiceBody = styled.div`
    padding: 24px;
`;

const InvoiceRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    .row-label {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #666;
        font-size: 14px;

        svg {
            font-size: 16px;
            color: #318cd5;
        }
    }

    .row-value {
        font-size: 15px;
        font-weight: 600;
        color: #1a1a2e;
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;

const PayButton = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: linear-gradient(135deg, #4caf50, #66bb6a);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
        color: white;
    }

    svg {
        font-size: 16px;
    }
`;

const ViewAllLink = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 14px;
    background: #f8f9fa;
    border: 2px dashed #ddd;
    border-radius: 10px;
    color: #318cd5;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 16px;

    &:hover {
        background: #e3f2fd;
        border-color: #318cd5;
    }

    svg {
        font-size: 16px;
    }
`;

const DaysRemaining = styled.span`
    font-size: 13px;
    color: #666;
    font-weight: 400;
`;

// =============================================
// STYLED COMPONENTS PARA MODAL DE FATURAS
// =============================================

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
`;

const ModalContainer = styled.div`
    background: white;
    border-radius: 20px;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
    animation: modalSlideIn 0.3s ease-out;

    @keyframes modalSlideIn {
        from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }
`;

const ModalHeader = styled.div`
    background: linear-gradient(135deg, #318cd5, #4facfe);
    padding: 24px 28px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
        display: flex;
        align-items: center;
        gap: 16px;

        .header-icon {
            width: 52px;
            height: 52px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                font-size: 24px;
            }
        }

        .header-text {
            h2 {
                margin: 0 0 4px 0;
                font-size: 22px;
                font-weight: 600;
            }

            p {
                margin: 0;
                opacity: 0.85;
                font-size: 14px;
            }
        }
    }

    .close-btn {
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.15);
        border: none;
        border-radius: 10px;
        color: white;
        font-size: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.25);
            transform: scale(1.05);
        }
    }
`;

const ModalBody = styled.div`
    padding: 24px;
    max-height: calc(90vh - 160px);
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
`;

const InvoicesTableStyled = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
`;

const TableHeaderStyled = styled.div`
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
    background: #f8f9fa;
    padding: 16px 20px;
    border-bottom: 2px solid #e8e8e8;

    @media (max-width: 600px) {
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    }
`;

const TableHeaderCell = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        font-size: 14px;
        color: #318cd5;
    }

    @media (max-width: 600px) {
        &:nth-child(3), &:nth-child(4) {
            display: none;
        }
    }
`;

const TableRowStyled = styled.div`
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;
    align-items: center;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f8f9fa;
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 16px;
    }
`;

const TableCell = styled.div`
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;

    &.date {
        font-weight: 600;
        color: #1a1a2e;
    }

    &.value {
        font-weight: 700;
        color: #318cd5;
        font-size: 15px;
    }

    @media (max-width: 600px) {
        &::before {
            content: attr(data-label);
            font-size: 11px;
            color: #888;
            text-transform: uppercase;
            font-weight: 600;
            min-width: 100px;
        }
    }
`;

const InvoiceStatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;

    ${({ $status }) => {
        switch ($status) {
            case 'PAID':
            case 'RECEIVED':
            case 'CONFIRMED':
                return `
                    background: #e8f5e9;
                    color: #2e7d32;
                `;
            case 'PENDING':
                return `
                    background: #fff3e0;
                    color: #e65100;
                `;
            case 'OVERDUE':
                return `
                    background: #ffebee;
                    color: #c62828;
                `;
            case 'CANCELED':
            case 'REFUNDED':
                return `
                    background: #f5f5f5;
                    color: #757575;
                `;
            default:
                return `
                    background: #e3f2fd;
                    color: #1565c0;
                `;
        }
    }}

    svg {
        font-size: 12px;
    }
`;

const PayButtonTable = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: linear-gradient(135deg, #4caf50, #66bb6a);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
    border: none;
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
        color: white;
    }

    svg {
        font-size: 14px;
    }
`;

const DisabledButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: #e0e0e0;
    color: #9e9e9e;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: not-allowed;

    svg {
        font-size: 14px;
    }
`;

const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;

    .empty-icon {
        width: 80px;
        height: 80px;
        background: linear-gradient(135deg, #f5f5f5, #e8e8e8);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        svg {
            font-size: 36px;
            color: #bdbdbd;
        }
    }

    h3 {
        margin: 0 0 8px 0;
        color: #333;
        font-size: 18px;
    }

    p {
        margin: 0;
        color: #888;
        font-size: 14px;
    }
`;

// statusMap is now handled via i18n: t('invoiceStatus.STATUS_KEY')
// Kept as fallback only - translations come from subscription.json invoiceStatus
const statusMap = {};

// =============================================
// STYLED COMPONENTS - CHECKOUT / CONTRATAÇÃO
// Prefixo único: pj-checkout-
// =============================================

const fadeInUp = keyframes`
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
`;

const shimmer = keyframes`
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
`;

const PjCheckoutWrapper = styled.div`
    animation: ${fadeInUp} 0.5s ease-out;

    .pj-checkout-hero {
        text-align: center;
        margin-bottom: 32px;

        h1 {
            font-size: 22px;
            font-weight: 600;
            color: #334155;
            margin: 0 0 8px;
        }

        p {
            font-size: 14px;
            color: #94a3b8;
            margin: 0;
            font-weight: 400;
        }
    }
`;

const PjCheckoutPlansGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
`;

const PjCheckoutPlanCard = styled.div`
    position: relative;
    background: #fff;
    border: 2px solid ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#e2e8f0'};
    border-radius: 16px;
    padding: 28px 24px;
    cursor: pointer;
    transition: all 0.25s ease;
    overflow: hidden;
    animation: ${fadeInUp} 0.5s ease-out;
    animation-delay: ${({ $delay }) => $delay || '0s'};
    animation-fill-mode: both;

    ${({ $active }) => $active && `
        background: linear-gradient(135deg, rgba(49, 140, 213, 0.05), rgba(79, 172, 254, 0.08));
        box-shadow: 0 4px 20px rgba(49, 140, 213, 0.15);
        border-color: rgb(49, 140, 213);
    `}

    &:hover {
        ${({ $active }) => !$active && `
            border-color: #94a3b8;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
        `}
    }

    .pj-checkout-plan-badge {
        position: absolute;
        top: 0;
        right: 24px;
        background: linear-gradient(135deg, #f59e0b, #f97316);
        color: white;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        padding: 6px 14px;
        border-radius: 0 0 10px 10px;
    }

    .pj-checkout-plan-name {
        font-size: 17px;
        font-weight: 600;
        color: #334155;
        margin-bottom: 16px;
    }

    .pj-checkout-plan-pricing {
        margin-bottom: 20px;

        .pj-checkout-plan-original-price {
            font-size: 14px;
            color: #94a3b8;
            text-decoration: line-through;
            margin-bottom: 4px;
        }

        .pj-checkout-plan-promo {
            font-size: 20px;
            font-weight: 800;
            color: rgb(49, 140, 213);
            margin-bottom: 2px;
        }

        .pj-checkout-plan-promo-label {
            font-size: 12px;
            color: rgb(49, 140, 213);
            font-weight: 600;
        }

        .pj-checkout-plan-after {
            font-size: 12px;
            color: #94a3b8;
            margin-top: 6px;
        }

        .pj-checkout-plan-main-price {
            font-size: 28px;
            font-weight: 700;
            color: #1e293b;
            line-height: 1;

            span {
                font-size: 14px;
                font-weight: 500;
                color: #64748b;
                margin-left: 2px;
            }
        }
    }

    .pj-checkout-plan-selected-label {
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }

    .pj-checkout-plan-cta {
        width: 100%;
        padding: 12px;
        border: 2px solid #e2e8f0;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #fff;
        color: #475569;

        &:hover {
            border-color: rgb(49, 140, 213);
            color: rgb(49, 140, 213);
            background: rgba(49, 140, 213, 0.03);
        }
    }
`;

const PjCheckoutPaymentSection = styled.div`
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 24px;
    animation: ${fadeInUp} 0.5s ease-out;
    animation-delay: 0.15s;
    animation-fill-mode: both;
`;

const PjCheckoutNotice = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #eff6ff, #dbeafe);
    border-bottom: 1px solid #e2e8f0;
    font-size: 13px;
    color: #1e40af;
    font-weight: 500;

    svg {
        font-size: 20px;
        flex-shrink: 0;
        color: #3b82f6;
    }
`;

const PjCheckoutPaymentMethods = styled.div`
    padding: 24px;

    .pj-checkout-payment-title {
        font-size: 15px;
        font-weight: 700;
        color: #1a1a2e;
        margin-bottom: 14px;
    }

    .pj-checkout-payment-options {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-bottom: 28px;

        @media (max-width: 600px) {
            grid-template-columns: 1fr;
        }
    }
`;

const PjCheckoutPaymentOption = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border: 2px solid ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#e2e8f0'};
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${({ $active }) => $active ? 'rgba(49, 140, 213, 0.04)' : '#fff'};

    &:hover {
        border-color: rgb(49, 140, 213);
    }

    .pj-checkout-payment-option-left {
        display: flex;
        align-items: center;
        gap: 10px;

        .pj-checkout-payment-radio {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 2px solid ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#cbd5e1'};
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            &::after {
                content: '';
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: ${({ $active }) => $active ? 'rgb(49, 140, 213)' : 'transparent'};
                transition: all 0.15s ease;
            }
        }

        span {
            font-size: 14px;
            font-weight: 600;
            color: ${({ $active }) => $active ? '#1a1a2e' : '#64748b'};
        }
    }

    .pj-checkout-payment-option-icon {
        font-size: 24px;
        color: ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#94a3b8'};
        transition: color 0.2s ease;
    }
`;

const PjCheckoutForm = styled.div`
    padding: 0 24px 24px;

    .pj-checkout-autofill-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 18px;
        background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-bottom: 20px;

        &:hover {
            box-shadow: 0 4px 12px rgba(49, 140, 213, 0.3);
            transform: translateY(-1px);
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
        }
    }

    .pj-checkout-person-type {
        margin-bottom: 20px;

        .pj-checkout-person-label {
            font-size: 13px;
            font-weight: 600;
            color: #475569;
            margin-bottom: 10px;
        }

        .pj-checkout-person-options {
            display: flex;
            gap: 16px;
        }
    }

    .pj-checkout-form-grid {
        display: grid;
        gap: 16px;
        margin-bottom: 16px;

        &.two-cols {
            grid-template-columns: 1fr 1fr;
            @media (max-width: 600px) { grid-template-columns: 1fr; }
        }

        &.three-cols {
            grid-template-columns: 1.5fr 1fr 1fr;
            @media (max-width: 600px) { grid-template-columns: 1fr; }
        }
    }

    .pj-checkout-field {
        display: flex;
        flex-direction: column;
        gap: 6px;

        label {
            font-size: 13px;
            font-weight: 600;
            color: #334155;

            .pj-checkout-required {
                color: #ef4444;
                margin-left: 2px;
            }
        }

        input {
            padding: 12px 14px;
            border: 2px solid #e2e8f0;
            border-radius: 10px;
            font-size: 14px;
            color: #1a1a2e;
            transition: all 0.2s ease;
            outline: none;
            background: #fff;

            &::placeholder {
                color: #94a3b8;
            }

            &:focus {
                border-color: rgb(49, 140, 213);
                box-shadow: 0 0 0 3px rgba(49, 140, 213, 0.1);
            }
        }

        .pj-checkout-field-error {
            font-size: 12px;
            color: #ef4444;
            font-weight: 500;
        }
    }
`;

const PjCheckoutPersonOption = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: 2px solid ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#e2e8f0'};
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${({ $active }) => $active ? 'rgba(49, 140, 213, 0.04)' : '#fff'};

    &:hover { border-color: rgb(49, 140, 213); }

    .pj-checkout-person-radio {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 2px solid ${({ $active }) => $active ? 'rgb(49, 140, 213)' : '#cbd5e1'};
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &::after {
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: ${({ $active }) => $active ? 'rgb(49, 140, 213)' : 'transparent'};
        }
    }

    .pj-checkout-person-info {
        .pj-checkout-person-title {
            font-size: 13px;
            font-weight: 700;
            color: #1a1a2e;
        }
        .pj-checkout-person-desc {
            font-size: 11px;
            color: #64748b;
        }
    }
`;

const PjCheckoutFooter = styled.div`
    padding: 20px 24px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 600px) {
        flex-direction: column-reverse;
    }

    .pj-checkout-total {
        font-size: 14px;
        color: #64748b;
        font-weight: 500;

        strong {
            font-size: 22px;
            color: #334155;
            font-weight: 700;
            margin-left: 6px;
        }
    }
`;

const PjCheckoutSubmitBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 14px 40px;
    background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s ease;
    min-width: 220px;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
        background-size: 200% 100%;
        animation: ${shimmer} 2.5s infinite;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(49, 140, 213, 0.35);

        &::before { opacity: 1; }
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
        transform: none;
    }

    @media (max-width: 600px) {
        width: 100%;
    }
`;

const PjCheckoutFeatures = styled.div`
    margin-top: 32px;
    animation: ${fadeInUp} 0.5s ease-out;
    animation-delay: 0.25s;
    animation-fill-mode: both;

    .pj-checkout-features-title {
        font-size: 15px;
        font-weight: 600;
        color: #475569;
        margin-bottom: 16px;
    }

    .pj-checkout-features-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .pj-checkout-feature-tag {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        background: #f1f5f9;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        color: #475569;
        transition: all 0.2s ease;

        &::before {
            content: '\\2713';
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
            background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
            color: white;
            border-radius: 50%;
            font-size: 10px;
            font-weight: 700;
            flex-shrink: 0;
        }

        &:hover {
            background: #e2e8f0;
        }
    }
`;

const InvoicesModal = ({ invoices, isOpen, onClose, t }) => {
    if (!isOpen) return null;

    const getStatusIcon = (status) => {
        switch (status) {
            case 'PAID':
            case 'RECEIVED':
            case 'CONFIRMED':
                return <FaCheckCircle />;
            case 'PENDING':
                return <FaSync />;
            case 'OVERDUE':
                return <FaTimesCircle />;
            default:
                return null;
        }
    };

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <div className="header-left">
                        <div className="header-icon">
                            <FaFileInvoiceDollar />
                        </div>
                        <div className="header-text">
                            <h2>{t('invoicesModal.title')}</h2>
                            <p>{t('invoicesModal.subtitle')}</p>
                        </div>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </ModalHeader>
                <ModalBody>
                    {invoices && invoices.length > 0 ? (
                        <InvoicesTableStyled>
                            <TableHeaderStyled>
                                <TableHeaderCell>
                                    <FaCalendarAlt /> {t('invoicesModal.dueDate')}
                                </TableHeaderCell>
                                <TableHeaderCell>
                                    <FaReceipt /> {t('invoicesModal.status')}
                                </TableHeaderCell>
                                <TableHeaderCell>
                                    <FaMoneyBillWave /> {t('invoicesModal.total')}
                                </TableHeaderCell>
                                <TableHeaderCell>
                                    {t('invoicesModal.action')}
                                </TableHeaderCell>
                            </TableHeaderStyled>
                            {invoices.map((invoice, index) => (
                                <TableRowStyled key={index}>
                                    <TableCell className="date" data-label={`${t('invoicesModal.dueDate')}:`}>
                                        <FaCalendarAlt style={{ color: '#318cd5', fontSize: 14 }} />
                                        {formatDateTz(invoice?.dueDate, "DD/MM/YYYY")}
                                    </TableCell>
                                    <TableCell data-label={`${t('invoicesModal.status')}:`}>
                                        <InvoiceStatusBadge $status={invoice?.status}>
                                            {getStatusIcon(invoice?.status)}
                                            {t(`invoiceStatus.${invoice?.status}`, { defaultValue: t('invoiceStatus.UNKNOWN') })}
                                        </InvoiceStatusBadge>
                                    </TableCell>
                                    <TableCell className="value" data-label={`${t('invoicesModal.total')}:`}>
                                        {(invoice?.status === "OVERDUE" || invoice?.status === "PENDING")
                                            ? ((invoice?.value || 0) - (invoice?.discount?.value || 0))
                                                .toLocaleString(regionConfig.currency.locale, { style: "currency", currency: regionConfig.currency.code })
                                            : (invoice?.value || 0)
                                                .toLocaleString(regionConfig.currency.locale, { style: "currency", currency: regionConfig.currency.code })
                                        }
                                    </TableCell>
                                    <TableCell data-label={`${t('invoicesModal.action')}:`}>
                                        {(invoice?.status === "OVERDUE" || invoice?.status === "PENDING") ? (
                                            <PayButtonTable
                                                href={invoice?.invoiceUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FaExternalLinkAlt /> {t('invoiceCard.pay')}
                                            </PayButtonTable>
                                        ) : (
                                            <DisabledButton disabled>
                                                <FaCheckCircle /> {t('invoiceCard.paid')}
                                            </DisabledButton>
                                        )}
                                    </TableCell>
                                </TableRowStyled>
                            ))}
                        </InvoicesTableStyled>
                    ) : (
                        <EmptyState>
                            <div className="empty-icon">
                                <FaFileInvoiceDollar />
                            </div>
                            <h3>{t('invoicesModal.emptyTitle')}</h3>
                            <p>{t('invoicesModal.emptyDescription')}</p>
                        </EmptyState>
                    )}
                </ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );
};

// ========== LOCAL SUBSCRIPTION PAGE (Non-Asaas regions) ==========

const LocalSubContainer = styled.div`
    display: flex;
    margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
    min-height: 100vh;
    transition: 150ms;
    background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);
    padding: 40px 20px;
    justify-content: center;
    align-items: flex-start;

    @media (max-width: 768px) {
        margin-left: 0;
        padding: 20px 12px;
    }

    .local-sub-wrapper {
        width: 100%;
        max-width: 560px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .local-sub-card {
        background: white;
        border-radius: 16px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        overflow: hidden;
    }

    .local-sub-card-header {
        background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
        padding: 28px 32px;
        display: flex;
        align-items: center;
        gap: 16px;
        color: white;

        .header-icon {
            width: 48px;
            height: 48px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            flex-shrink: 0;
        }

        .header-text {
            h2 {
                margin: 0;
                font-size: 20px;
                font-weight: 700;
            }
            p {
                margin: 4px 0 0;
                font-size: 13px;
                opacity: 0.85;
            }
        }
    }

    .local-sub-card-body {
        padding: 28px 32px;
    }

    .local-sub-status-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.3px;

        &.active { background: #e6f9ee; color: #0d7a3e; }
        &.trial { background: #e8f4fd; color: #1a73e8; }
        &.expiring_soon { background: #fff3e0; color: #e65100; }
        &.expired { background: #fce4ec; color: #c62828; }
        &.inactive { background: #f5f5f5; color: #616161; }
        &.suspended { background: #fce4ec; color: #c62828; }
    }

    .local-sub-days-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 0;
        gap: 8px;

        .days-number {
            font-size: 56px;
            font-weight: 800;
            line-height: 1;
            color: #1a1a2e;

            &.expired { color: #c62828; }
            &.warning { color: #e65100; }
            &.active { color: rgb(49, 140, 213); }
        }

        .days-label {
            font-size: 15px;
            color: #666;
            font-weight: 500;
        }
    }

    .local-sub-progress-wrapper {
        padding: 0 0 20px;

        .progress-bar-bg {
            width: 100%;
            height: 8px;
            background: #e8ecf1;
            border-radius: 4px;
            overflow: hidden;

            .progress-bar-fill {
                height: 100%;
                border-radius: 4px;
                transition: width 0.6s ease;

                &.green { background: linear-gradient(90deg, #4caf50, #66bb6a); }
                &.orange { background: linear-gradient(90deg, #ff9800, #ffa726); }
                &.red { background: linear-gradient(90deg, #ef5350, #e53935); }
            }
        }

        .progress-label {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            font-size: 12px;
            color: #999;
        }
    }

    .local-sub-info-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child { border-bottom: none; }

        .info-label {
            font-size: 14px;
            color: #888;
            display: flex;
            align-items: center;
            gap: 8px;

            svg { font-size: 14px; color: #aaa; }
        }

        .info-value {
            font-size: 14px;
            font-weight: 600;
            color: #333;
        }
    }

    .local-sub-contact-card {
        background: white;
        border-radius: 16px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        padding: 28px 32px;
        text-align: center;

        .contact-icon {
            width: 52px;
            height: 52px;
            background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
            color: white;
            font-size: 22px;
        }

        p {
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin: 0 0 20px;
        }

        .contact-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 12px 32px;
            background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
            color: white;
            border: none;
            border-radius: 10px;
            font-size: 15px;
            font-weight: 600;
            text-decoration: none;
            cursor: pointer;
            transition: all 0.2s ease;
            box-shadow: 0 4px 12px rgba(49, 140, 213, 0.3);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(49, 140, 213, 0.4);
            }
        }
    }

    .local-sub-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 20px;
        gap: 16px;
        color: #888;
        font-size: 15px;
    }
`;

const LocalSubscriptionPage = ({ sidebar, t }) => {
    const [licenseData, setLicenseData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await verificarLicencaLocal();
                setLicenseData(response.data);
            } catch (error) {
                console.error('[PLANOS] Error fetching local license:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return (
            <LocalSubContainer sidebar={sidebar}>
                <div className="local-sub-wrapper">
                    <div className="local-sub-loading">
                        <Loading type="spin" color="rgb(49, 140, 213)" width={40} height={40} />
                        <span>{t('adminSubscription.loading', 'Loading...')}</span>
                    </div>
                </div>
            </LocalSubContainer>
        );
    }

    const status = licenseData?.status || 'expired';
    const diasParaExpirar = licenseData?.diasParaExpirar;
    const dataVencimento = licenseData?.dataVencimento;
    const hasLicense = licenseData?.hasLicense || false;
    const statusPlano = licenseData?.statusPlano || 'trial';

    // Status badge config
    const getStatusConfig = (s) => {
        switch (s) {
            case 'ativo': return { class: 'active', label: t('localSubscription.statusActive'), icon: <FaCheckCircle /> };
            case 'trial': return { class: 'trial', label: t('localSubscription.statusTrial'), icon: <FaClock /> };
            case 'expirando_em_breve': return { class: 'expiring_soon', label: t('localSubscription.statusExpiringSoon'), icon: <FaClock /> };
            case 'expirado': return { class: 'expired', label: t('localSubscription.statusExpired'), icon: <FaTimesCircle /> };
            case 'inativo': return { class: 'inactive', label: t('localSubscription.statusInactive'), icon: <FaTimesCircle /> };
            case 'suspenso': return { class: 'suspended', label: t('localSubscription.statusSuspended'), icon: <FaTimesCircle /> };
            default: return { class: 'trial', label: status, icon: <FaClock /> };
        }
    };

    const statusConfig = getStatusConfig(status);

    // Days display logic
    const absDays = Math.abs(diasParaExpirar || 0);
    const isExpired = diasParaExpirar !== null && diasParaExpirar < 0;
    const isWarning = diasParaExpirar !== null && diasParaExpirar >= 0 && diasParaExpirar <= 7;

    // Progress bar calculation (for trial: 30 days, otherwise estimate)
    const totalDays = status === 'trial' ? 30 : 365;
    const usedDays = diasParaExpirar !== null ? Math.max(0, totalDays - diasParaExpirar) : totalDays;
    const progressPercent = diasParaExpirar !== null ? Math.min(100, Math.max(0, (diasParaExpirar / totalDays) * 100)) : 0;
    const progressColor = progressPercent > 30 ? 'green' : progressPercent > 10 ? 'orange' : 'red';

    // Format date
    const formattedDate = dataVencimento
        ? formatDateTz(dataVencimento)
        : t('localSubscription.noExpirySet');

    const supportUrl = regionConfig.brand.supportUrl || `https://${regionConfig.brand.domain}`;

    return (
        <LocalSubContainer sidebar={sidebar}>
            <div className="local-sub-wrapper">
                {/* Main Status Card */}
                <div className="local-sub-card">
                    <div className="local-sub-card-header">
                        <div className="header-icon">
                            <FaCrown />
                        </div>
                        <div className="header-text">
                            <h2>{t('localSubscription.title')}</h2>
                            {status === 'trial' && (
                                <p>{t('localSubscription.trialPeriod')}</p>
                            )}
                        </div>
                    </div>

                    <div className="local-sub-card-body">
                        {/* Status Badge */}
                        <div style={{ marginBottom: '20px' }}>
                            <span className={`local-sub-status-badge ${statusConfig.class}`}>
                                {statusConfig.icon} {statusConfig.label}
                            </span>
                        </div>

                        {/* Days Remaining - Big Number */}
                        {diasParaExpirar !== null && (
                            <div className="local-sub-days-section">
                                <div className={`days-number ${isExpired ? 'expired' : isWarning ? 'warning' : 'active'}`}>
                                    {absDays}
                                </div>
                                <div className="days-label">
                                    {isExpired
                                        ? t('localSubscription.daysExpired', { days: absDays })
                                        : absDays === 1
                                            ? t('localSubscription.dayRemaining', { days: absDays })
                                            : t('localSubscription.daysRemaining', { days: absDays })
                                    }
                                </div>
                            </div>
                        )}

                        {/* Progress Bar */}
                        {diasParaExpirar !== null && diasParaExpirar >= 0 && (
                            <div className="local-sub-progress-wrapper">
                                <div className="progress-bar-bg">
                                    <div
                                        className={`progress-bar-fill ${progressColor}`}
                                        style={{ width: `${progressPercent}%` }}
                                    />
                                </div>
                                <div className="progress-label">
                                    <span>{t('localSubscription.progressLabel', { used: usedDays, total: totalDays })}</span>
                                </div>
                            </div>
                        )}

                        {/* Info Rows */}
                        <div className="local-sub-info-row">
                            <div className="info-label">
                                <FaCalendarAlt />
                                {isExpired
                                    ? t('localSubscription.expiredOn', { date: '' }).replace('{{date}}', '').trim()
                                    : t('localSubscription.expiresOn', { date: '' }).replace('{{date}}', '').trim()
                                }
                            </div>
                            <div className="info-value">{formattedDate}</div>
                        </div>

                        <div className="local-sub-info-row">
                            <div className="info-label">
                                <FaCrown />
                                {t('localSubscription.planLabel')}
                            </div>
                            <div className="info-value" style={{ textTransform: 'capitalize' }}>
                                {statusPlano || '-'}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Support Card */}
                <div className="local-sub-contact-card">
                    <div className="contact-icon">
                        <FaHeadset />
                    </div>
                    <p>{t('localSubscription.contactDescription')}</p>
                    <a
                        href={supportUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-btn"
                    >
                        <FaHeadset />
                        {t('localSubscription.contactSupport')}
                    </a>
                </div>
            </div>
        </LocalSubContainer>
    );
};

// ========== END LOCAL SUBSCRIPTION PAGE ==========

const Planos = () => {
    const { t } = useTranslation('subscription');
    const { sidebar } = useContext(SidebarContext);; //TESTANDO CONST NO AppROUTES

    const asaasEnabled = isFeatureEnabled('asaas');
    const currentDay = nowTz().format('DD');

    const [payment_type, setPayment_type] = useState("");
    const [person_type, setPerson_type] = useState("cnpj");
    const [plan_cycle, setPlan_cycle] = useState("");
    const [plan_type, setPlan_type] = useState("silver"); //silver, gold, premium


    const [isFinalizando, setIsFinalizando] = useState(false);

    const userParse = getStoredUser();
    const userID = userParse?._id;
    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const idEmpresa = empresaParse.id_empresa;
    const [planos, setPlanos] = useState([]);
    const [priceToPay, setPriceToPay] = useState("");
    const [assinatura, setAssinatura] = useState({});

    const [seeAllPlans, setSeeAllPlans] = useState(false);
    const [loadingCustomerData, setLoadingCustomerData] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [clienteAsaas, setClienteAsaas] = useState(null);
    const [empresaFromDB, setEmpresaFromDB] = useState(null);
    const [loadingAssinaturas, setLoadingAssinaturas] = useState(true);
    const [licencaLocal, setLicencaLocal] = useState(null);
    const [licencaAsaas, setLicencaAsaas] = useState(null);
    const [isPromotional, setIsPromotional] = useState(false);

    const [ip, setIp] = useState("");
    const getUserIp = async () => {
        const ip = await axios.get('https://api64.ipify.org?format=json');
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(ip.data.ip);
        setIp(ip.data.ip)
    }

    useEffect(() => {
        getUserIp();
    }, [refresh]);

    // Carregar planos disponíveis
    useEffect(() => {
        const fetchPlanos = async () => {
            try {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('[PLANOS] Buscando planos disponíveis...');
                const response = await getPlansAsaas();
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('[PLANOS] Planos recebidos:', response.data);
                
                // Estrutura de resposta: { planos: { planos: [...] } }
                const planosData = response.data?.planos?.planos || [];
                setPlanos(planosData);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('[PLANOS] Planos carregados:', planosData.length);
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('[PLANOS] Erro ao carregar planos:', error);
                setPlanos([]); // Fallback para array vazio
            }
        };

        fetchPlanos();
    }, []);

    useEffect(() => {
        const fetchAssinaturasAndInvoices = async () => {
            setLoadingAssinaturas(true); // Inicia o estado de carregamento
            try {
                const empresaTemp = await getEmpresa(userID, idEmpresa);
                setEmpresaFromDB(empresaTemp?.data.empresa);

                // Verifica se o getDaysToExpireLicense retorna 404
                let hasLocalSubscription = true;
                try {
                    await await getDaysToExpireLicense();
                } catch (error) {
                    if (error.response?.status === 404) {
                        hasLocalSubscription = false;
                    }
                }

                // Buscar licença local (baseada na data de vencimento no banco)
                try {
                    const licencaLocalResponse = await verificarLicencaLocal();
                    setLicencaLocal(licencaLocalResponse.data);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Licença Local:", licencaLocalResponse.data);
                } catch (error) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.warn("Erro ao buscar licença local:", error);
                }

                // Buscar licença Asaas (baseada em faturas ativas)
                try {
                    const licencaAsaasResponse = await verificarLicencaAsaas();
                    setLicencaAsaas(licencaAsaasResponse.data);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Licença Asaas:", licencaAsaasResponse.data);
                } catch (error) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.warn("Erro ao buscar licença Asaas:", error);
                }

                if (empresaTemp?.data.empresa.customer_asaas) {
                    await listarAssinaturas(empresaTemp?.data.empresa.customer_asaas, hasLocalSubscription);
                } else {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.warn("customer_asaas não encontrado na empresa.");
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar assinaturas ou invoices:", error);
            } finally {
                setLoadingAssinaturas(false); // Finaliza o estado de carregamento
            }
        };

        fetchAssinaturasAndInvoices();
    }, [refresh]);

    const listarAssinaturas = async (customer_asaas_id, hasLocalSubscription) => {
        try {
            const assinaturas = await listarAssinaturasAsaas(customer_asaas_id);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Assinaturas>", assinaturas);

            const clienteAsaasTemp = await getDataCustomerAsaas(customer_asaas_id);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Cliente Asaas>", clienteAsaasTemp);

            // Todas as faturas
            const allInvoicesTemp = assinaturas?.data?.paymentData?.data;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("All Invoices:::", allInvoicesTemp);

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("OQ VOLTOU do listarAssinaturas", assinaturas);
            // Verifica se a assinatura está inativa E não há faturas E não tem assinatura local
            const subscriptionData = assinaturas?.data?.subscriptionData?.data[0];
            if ((subscriptionData?.status === "INACTIVE" && (!allInvoicesTemp || allInvoicesTemp.length === 0)) || !hasLocalSubscription) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Assinatura inativa/sem faturas ou sem assinatura local. Mostrando tela de criação.");
                setAssinatura({});
                setClienteAsaas(null);
                setInvoiceData(null);
                setInvoices([]);
                setSeeAllPlans(true);
                return;
            }

            let lastInvoiceTemp = null;

            if (allInvoicesTemp && allInvoicesTemp.length > 0) {
                // Filtra as faturas com status PENDING ou OVERDUE
                const filteredInvoices = allInvoicesTemp.filter(invoice =>
                    invoice.status === "OVERDUE" || invoice.status === "PENDING"
                );

                // Ordena as faturas com prioridade para OVERDUE
                const sortedInvoices = filteredInvoices.sort((a, b) => {
                    if (a.status === b.status) {
                        // Se os status forem iguais, ordena pela data mais recente
                        return new Date(b.dueDate) - new Date(a.dueDate);
                    }
                    // PRIORIDADE: OVERDUE > PENDING
                    return a.status === "OVERDUE" ? -1 : 1;
                });

                // O invoice mais recente com status prioritário
                lastInvoiceTemp = sortedInvoices[0];

                // Caso não encontre nenhuma fatura PENDING ou OVERDUE, pega a última fatura mais recente
                if (!lastInvoiceTemp) {
                    lastInvoiceTemp = allInvoicesTemp.sort((a, b) => {
                        return new Date(b.dueDate) - new Date(a.dueDate);
                    })[0];
                }
            }

            // Define o objeto de assinatura no estado
            setAssinatura(subscriptionData);
            setClienteAsaas(clienteAsaasTemp?.data);

            // Define o último invoice no estado
            if (lastInvoiceTemp) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("lastInvoiceTemp::", lastInvoiceTemp);
                setInvoiceData(lastInvoiceTemp);
            } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.warn("Nenhuma fatura encontrada.");
            }

            // Define todas as faturas no estado
            if (allInvoicesTemp) {
                setInvoices(allInvoicesTemp);
            } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.warn("Nenhuma fatura encontrada para a assinatura.");
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao listar assinaturas ou faturas:", error);
            // Em caso de erro, mantém o estado atual
            // Não vamos mostrar a tela de criação automaticamente em caso de erro
        }
    };

    const handlePaymentType = (tipo_pagamento) => {
        if (tipo_pagamento === "CREDIT_CARD") {
            setPayment_type("CREDIT_CARD");
        } else if (tipo_pagamento === "BOLETO") {
            setPayment_type("BOLETO");
        } else if (tipo_pagamento === "PIX") {
            setPayment_type("PIX");
        }
    }

    const handlePersonType = (tipo_pessoa) => {
        if (tipo_pessoa === "cnpj") {
            setPerson_type("cnpj");
        } else if (tipo_pessoa === "cpf") {
            setPerson_type("cpf");
        }
    }



    const handleGetDataCustomer = async () => {
        try {
            setLoadingCustomerData(true);

            const customerAsaasId = empresaFromDB?.customer_asaas;
            const isCustomerIdValid = (
                customerAsaasId &&
                typeof customerAsaasId === 'string' &&
                customerAsaasId.trim() !== '' &&
                customerAsaasId !== 'null' &&
                customerAsaasId !== 'undefined'
            );

            if (isCustomerIdValid) {
                // Buscar dados do cliente no Asaas
                const response = await getDataCustomerAsaas(customerAsaasId);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Reponse getDataCustomerAsaas:::", response.data);

                if (response.data) {
                    const result = response.data;
                    formik.setValues({
                        cpf_cnpj: result.cpfCnpj || "",
                        nomeOrRazao: result.name || "",
                        email: result.email || "",
                        cep: result.postalCode || "",
                        numero: result.addressNumber || "",
                    });

                    if (result.cpfCnpj && result.cpfCnpj.length > 11) {
                        setPerson_type("cnpj");
                    } else {
                        setPerson_type("cpf");
                    }
                    toast.success(t('form.dataLoadedFromAsaas', { defaultValue: 'Dados carregados com sucesso!' }));
                    return;
                }
            }

            // Fallback: usar dados da empresa local
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("[PLANOS] customer_asaas não disponível, usando dados locais da empresa");

            if (empresaFromDB) {
                formik.setValues({
                    cpf_cnpj: empresaFromDB.cnpj || "",
                    nomeOrRazao: empresaFromDB.name || "",
                    email: empresaFromDB.email || "",
                    cep: empresaFromDB.cep || "",
                    numero: empresaFromDB.address_number || "",
                });

                if (empresaFromDB.cnpj && empresaFromDB.cnpj.replace(/\D/g, '').length > 11) {
                    setPerson_type("cnpj");
                } else {
                    setPerson_type("cpf");
                }
                toast.success(t('form.dataLoadedFromLocal', { defaultValue: 'Dados carregados do cadastro!' }));
            } else {
                toast.warning(t('form.noDataFound', { defaultValue: 'Nenhum dado encontrado para preencher.' }));
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao obter dados do cliente:", error);

            // Mesmo em caso de erro no Asaas, tenta fallback local
            if (empresaFromDB) {
                formik.setValues({
                    cpf_cnpj: empresaFromDB.cnpj || "",
                    nomeOrRazao: empresaFromDB.name || "",
                    email: empresaFromDB.email || "",
                    cep: empresaFromDB.cep || "",
                    numero: empresaFromDB.address_number || "",
                });

                if (empresaFromDB.cnpj && empresaFromDB.cnpj.replace(/\D/g, '').length > 11) {
                    setPerson_type("cnpj");
                } else {
                    setPerson_type("cpf");
                }
                toast.info(t('form.dataLoadedFromLocalFallback', { defaultValue: 'Dados carregados do cadastro local.' }));
            } else {
                toast.error(t('form.errorLoadingData', { defaultValue: 'Erro ao carregar dados.' }));
            }
        } finally {
            setLoadingCustomerData(false);
        }
    }

    //Validações
    const SignUpSchema = Yup.object().shape({
        //tipo_pessoa: Yup.string().required(t('validation.required')),
        cpf_cnpj: Yup.string().required(t('validation.required')),
        nomeOrRazao: Yup.string().required(t('validation.required')),
        email: Yup.string().email(t('validation.invalidEmail')).required(t('validation.required')),
        cep: Yup.string().required(t('validation.required')),
        numero: Yup.string().required(t('validation.required')),
        //telefone: Yup.string().required("Campo obrigatório"),

        /*num_cartao: Yup.string()
        .test('test-number', // this is used internally by yup
        'Cartão de crédito invalido', //validation message
        value => valid.number(value).isValid) // return true false based on validation
        .required("Campo obrigatório"),  

        validade: Yup.string().required("Campo obrigatório"),

        cvv: Yup.string()
        .matches(/^[0-9]{3,4}$/, 'CVV inválido') 
        .required("Campo obrigatório")
        */

    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        //enableReinitialize: true,
        initialValues: {
            tipo_pessoa: "",
            num_cartao: "",
            validade: "",
            cvv: "",
            cpf_cnpj: "",
            nomeOrRazao: "",
            parcelas: 1,
            email: "",
            cep: "",
            numero: "",
            telefone: "",
        },
        onSubmit: (values) => {

            //const tipo_pessoa = values.tipo_pessoa;

            const cpf_cnpj = values.cpf_cnpj;
            const nomeOrRazao = values.nomeOrRazao;
            const parcelas = values.parcelas;
            const email = values.email;
            const cep = values.cep;
            const numero = values.numero;


            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("PARCELAS>", parcelas)

            handleSubmitAPI(cpf_cnpj, nomeOrRazao, email, cep, numero, parcelas);

        },
    });

    const handleSubmitAPI = async (cpf_cnpj, nomeOrRazao, email, cep, numero, parcelas) => {
        setIsFinalizando(true);

        const createdBy = userID;
        const name = nomeOrRazao;
        const zip_code = cep;
        const number = numero;
        const plan_identifier = plan_type;

        try {

            // Chama a função para buscar/registrar cliente e criar a assinatura
            const response = await searchClienteAsaasAndGetInvoice(createdBy, email, name, cpf_cnpj, zip_code, number, plan_identifier, payment_type, isPromotional);

            // Verifica se o invoiceUrl foi retornado com sucesso
            if (response && response.data.invoiceUrl) {
                // Abre uma nova aba com a URL da invoice
                window.open(response.data.invoiceUrl, '_blank');
                toast(t('toasts.subscriptionCreatedWithInvoice'),
                      { autoClose: 5000, type: "success" });
                // Aguarda um pequeno delay antes de atualizar a página para garantir que a guia foi aberta
                setTimeout(() => {
                    window.location.reload();
                }, 1500); // Atualiza após 1.5 segundos
            } else {
                // Se não há invoiceUrl, ainda mostra sucesso mas orienta o usuário
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Assinatura criada, mas URL da fatura não está disponível ainda');
                toast(t('toasts.subscriptionCreatedNoInvoice'),
                      { autoClose: 7000, type: "success" });
                setTimeout(() => {
                    window.location.reload();
                }, 2000); // Atualiza após 2 segundos
            }


        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao processar a assinatura:', error.response.data.msg);
            toast(error.response.data.msg, { autoClose: 3000, type: "error" });
        } finally {
            setIsFinalizando(false); // Finaliza o loading ou processo
            setRefresh((prev) => !prev);
        }

    }

    const valorCentsConvertido = (value) => {
        const valorConvertido = value / 100;
        return valorConvertido.toFixed(2).toString().replace('.', ',');
    }


    /*const handleChoosePlan = (plan_identifier, planCycle, valor_plano, isPromotionalPrice, valorPromocional) => {
        setPlan_type(plan_identifier);
        setPlan_cycle(planCycle);
        //const valueToPay = valorCentsConvertido(valor_plano);
        isPromotionalPrice ? setPriceToPay(valorPromocional) : setPriceToPay(valor_plano);
        if (isPromotionalPrice) {
            setIsPromotional(true)
        }

    }*/
    const handleChoosePlan = (plan_identifier, planCycle, valor_plano, isPromotional = false) => {
        setPlan_type(plan_identifier);
        setPlan_cycle(planCycle);
        if (isPromotional) {
            setPriceToPay(19.90); // Preço promocional
            setIsPromotional(true);
        } else {
            setPriceToPay(valor_plano);
            setIsPromotional(false);
        }
    }

    // If online subscriptions are not available (e.g., Lebanon), show local subscription status
    if (!asaasEnabled) {
        return (
            <LocalSubscriptionPage
                sidebar={sidebar}
                t={t}
            />
        );
    }

    return (
        <div>
            {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}
            <Teste sidebar={sidebar}>
                <InvoicesModal
                    invoices={invoices}
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    t={t}
                />
                <div className="planos">
                    
                        <div className="formGroupRowPlanos">
                            <div className="subscription-layout">
                                {
                                    assinatura && Object.keys(assinatura).length > 0 && assinatura.externalReference !== "free_trial" && !seeAllPlans ?
                                        <div style={{ width: '100%' }}>
                                            {/* Card de Assinatura */}
                                            <SubscriptionCard>
                                                <SubscriptionHeader>
                                                    <div className="header-content">
                                                        <div className="icon-box">
                                                            <FaCrown />
                                                        </div>
                                                        <div className="header-text">
                                                            <h2>{t('pageTitle')}</h2>
                                                            <p>{t('pageSubtitle')}</p>
                                                        </div>
                                                    </div>
                                                </SubscriptionHeader>
                                                <SubscriptionBody>
                                                    <InfoGrid>
                                                        {/* Nome do Cliente */}
                                                        <InfoItem $iconBg="linear-gradient(135deg, #667eea, #764ba2)">
                                                            <div className="info-icon">
                                                                <FaUser />
                                                            </div>
                                                            <div className="info-content">
                                                                <div className="info-label">{t('subscriptionCard.customerName')}</div>
                                                                <div className="info-value">{clienteAsaas?.name || '-'}</div>
                                                            </div>
                                                        </InfoItem>

                                                        {/* Email */}
                                                        <InfoItem $iconBg="linear-gradient(135deg, #f093fb, #f5576c)">
                                                            <div className="info-icon">
                                                                <FaEnvelope />
                                                            </div>
                                                            <div className="info-content">
                                                                <div className="info-label">{t('subscriptionCard.customerEmail')}</div>
                                                                <div className="info-value">{clienteAsaas?.email || '-'}</div>
                                                            </div>
                                                        </InfoItem>

                                                        {/* Plano */}
                                                        <InfoItem $iconBg="linear-gradient(135deg, #4facfe, #00f2fe)">
                                                            <div className="info-icon">
                                                                <FaCrown />
                                                            </div>
                                                            <div className="info-content">
                                                                <div className="info-label">{t('subscriptionCard.plan')}</div>
                                                                <div className="info-value">{assinatura.description || '-'}</div>
                                                            </div>
                                                        </InfoItem>

                                                        {/* Status Assinatura */}
                                                        <InfoItem $iconBg={assinatura.status === "ACTIVE" ? "linear-gradient(135deg, #11998e, #38ef7d)" : "linear-gradient(135deg, #eb3349, #f45c43)"}>
                                                            <div className="info-icon">
                                                                {assinatura.status === "ACTIVE" ? <FaCheckCircle /> : <FaTimesCircle />}
                                                            </div>
                                                            <div className="info-content">
                                                                <div className="info-label">{t('subscriptionCard.subscription')}</div>
                                                                <div className="info-value">
                                                                    <StatusBadge $status={assinatura.status === "ACTIVE" ? 'active' : 'inactive'}>
                                                                        {assinatura.status === "ACTIVE" ? <><FaCheckCircle /> {t('subscriptionCard.active')}</> : <><FaTimesCircle /> {t('subscriptionCard.inactive')}</>}
                                                                    </StatusBadge>
                                                                </div>
                                                            </div>
                                                        </InfoItem>

                                                        {/* Status Pagamento */}
                                                        {licencaAsaas && (
                                                            <InfoItem $iconBg={licencaAsaas.licenseValid ? "linear-gradient(135deg, #11998e, #38ef7d)" : "linear-gradient(135deg, #eb3349, #f45c43)"}>
                                                                <div className="info-icon">
                                                                    {licencaAsaas.licenseValid ? <FaCheckCircle /> : <FaTimesCircle />}
                                                                </div>
                                                                <div className="info-content">
                                                                    <div className="info-label">{t('subscriptionCard.paymentStatus')}</div>
                                                                    <div className="info-value">
                                                                        <StatusBadge $status={licencaAsaas.licenseValid ? 'active' : 'inactive'}>
                                                                            {licencaAsaas.licenseValid ? <><FaCheckCircle /> {t('subscriptionCard.upToDate')}</> : <><FaTimesCircle /> {t('subscriptionCard.pending')}</>}
                                                                        </StatusBadge>
                                                                    </div>
                                                                </div>
                                                            </InfoItem>
                                                        )}

                                                        {/* Licenca Sistema */}
                                                        {licencaLocal && (
                                                            <InfoItem $iconBg={licencaLocal.licenseValid ? "linear-gradient(135deg, #11998e, #38ef7d)" : "linear-gradient(135deg, #eb3349, #f45c43)"}>
                                                                <div className="info-icon">
                                                                    {licencaLocal.licenseValid ? <FaCheckCircle /> : <FaTimesCircle />}
                                                                </div>
                                                                <div className="info-content">
                                                                    <div className="info-label">{t('subscriptionCard.systemLicense')}</div>
                                                                    <div className="info-value">
                                                                        <StatusBadge $status={licencaLocal.licenseValid ? 'valid' : 'invalid'}>
                                                                            {licencaLocal.licenseValid ? <><FaCheckCircle /> {t('subscriptionCard.valid')}</> : <><FaTimesCircle /> {t('subscriptionCard.expired')}</>}
                                                                        </StatusBadge>
                                                                        {licencaLocal.diasParaExpirar !== null && (
                                                                            <DaysRemaining>
                                                                                ({licencaLocal.diasParaExpirar > 0 ? t('subscriptionCard.daysRemaining', { days: licencaLocal.diasParaExpirar }) : t('subscriptionCard.expiredLabel')})
                                                                            </DaysRemaining>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </InfoItem>
                                                        )}

                                                        {/* Ciclo */}
                                                        {assinatura.externalReference !== "free_trial" && (
                                                            <InfoItem $iconBg="linear-gradient(135deg, #fa709a, #fee140)">
                                                                <div className="info-icon">
                                                                    <FaSync />
                                                                </div>
                                                                <div className="info-content">
                                                                    <div className="info-label">{t('subscriptionCard.cycle')}</div>
                                                                    <div className="info-value">
                                                                        {assinatura.cycle === "MONTHLY" ? t('subscriptionCard.cycleMonthly') : assinatura.cycle === "WEEKLY" ? t('subscriptionCard.cycleWeekly') : assinatura.cycle === "YEARLY" ? t('subscriptionCard.cycleYearly') : "-"}
                                                                    </div>
                                                                </div>
                                                            </InfoItem>
                                                        )}
                                                    </InfoGrid>
                                                </SubscriptionBody>
                                            </SubscriptionCard>

                                            {/* Card de Fatura */}
                                            {assinatura.externalReference !== "free_trial" ? (
                                                <InvoiceCard>
                                                    <InvoiceHeader>
                                                        <div className="invoice-icon">
                                                            <FaFileInvoiceDollar />
                                                        </div>
                                                        <h3>{t('invoiceCard.title')}</h3>
                                                    </InvoiceHeader>
                                                    <InvoiceBody>
                                                        <InvoiceRow>
                                                            <div className="row-label">
                                                                <FaCalendarAlt />
                                                                {t('invoiceCard.dueDate')}
                                                            </div>
                                                            <div className="row-value">
                                                                {formatDateTz(invoiceData?.dueDate, 'DD/MM/YYYY')}
                                                            </div>
                                                        </InvoiceRow>

                                                        <InvoiceRow>
                                                            <div className="row-label">
                                                                <FaReceipt />
                                                                {t('invoiceCard.invoiceStatus')}
                                                            </div>
                                                            <div className="row-value">
                                                                {t(`invoiceStatus.${invoiceData?.status}`) || t('invoiceCard.unknownStatus')}
                                                                {(invoiceData?.status === "OVERDUE" || invoiceData?.status === "PENDING") && (
                                                                    <PayButton href={invoiceData?.invoiceUrl} target="_blank" rel="noopener noreferrer">
                                                                        <FaExternalLinkAlt /> {t('invoiceCard.pay')}
                                                                    </PayButton>
                                                                )}
                                                            </div>
                                                        </InvoiceRow>

                                                        <InvoiceRow>
                                                            <div className="row-label">
                                                                <FaMoneyBillWave />
                                                                {t('invoiceCard.total')}
                                                            </div>
                                                            <div className="row-value" style={{ fontSize: '18px', color: '#318cd5' }}>
                                                                {(invoiceData?.status === "OVERDUE" || invoiceData?.status === "PENDING")
                                                                    ? formatPriceWithSymbol((invoiceData?.value || 0) - (invoiceData?.discount?.value || 0))
                                                                    : formatPriceWithSymbol(invoiceData?.value || 0)
                                                                }
                                                            </div>
                                                        </InvoiceRow>

                                                        <ViewAllLink onClick={() => setIsModalOpen(true)}>
                                                            <FaReceipt />
                                                            {t('invoiceCard.viewAll')}
                                                        </ViewAllLink>
                                                    </InvoiceBody>
                                                </InvoiceCard>
                                            ) : (
                                                <InvoiceCard>
                                                    <InvoiceBody>
                                                        <InfoItem $iconBg={assinatura.active ? "linear-gradient(135deg, #11998e, #38ef7d)" : "linear-gradient(135deg, #eb3349, #f45c43)"}>
                                                            <div className="info-icon">
                                                                {assinatura.active ? <FaCheckCircle /> : <FaTimesCircle />}
                                                            </div>
                                                            <div className="info-content">
                                                                <div className="info-label">{t('invoiceCard.licenseStatus')}</div>
                                                                <div className="info-value">
                                                                    <StatusBadge $status={assinatura.active ? 'active' : 'inactive'}>
                                                                        {assinatura.active ? t('invoiceCard.activeLabel') : t('invoiceCard.deactivatedLabel')}
                                                                    </StatusBadge>
                                                                </div>
                                                            </div>
                                                        </InfoItem>
                                                    </InvoiceBody>
                                                </InvoiceCard>
                                            )}
                                        </div>
                                        :
                                        <PjCheckoutWrapper>
                                            <div className="pj-checkout-hero">
                                                <h1>{t('noSubscription.title')}</h1>
                                                <p>{t('noSubscription.subtitle')}</p>
                                            </div>

                                            <PjCheckoutPlansGrid>
                                                {
                                                    planos && !loadingAssinaturas ? planos
                                                        .sort((a, b) => a.order - b.order)
                                                        .filter((plano) => plano.plan_identifier !== "free_trial")
                                                        .map((plano, index) => {
                                                            const valorOriginal = plano.valor_plano;
                                                            const createdDateEmpresa = toTz(empresaFromDB?.createdAt);
                                                            const currentDate = nowTz();
                                                            const monthsDifference = currentDate.diff(createdDateEmpresa, 'months');
                                                            const showPromotionalPrice = monthsDifference < 6 && plano.plan_cycle === "MONTHLY";
                                                            const isActive = plan_type === plano.plan_identifier;

                                                            return (
                                                                <PjCheckoutPlanCard
                                                                    key={plano._id}
                                                                    $active={isActive}
                                                                    $delay={`${index * 0.08}s`}
                                                                    onClick={() => handleChoosePlan(plano.plan_identifier, plano.plan_cycle, plano.valor_plano, showPromotionalPrice)}
                                                                >
                                                                    {plano.plan_cycle === "YEARLY" && (
                                                                        <div className="pj-checkout-plan-badge">{t('plans.recommended')}</div>
                                                                    )}
                                                                    <div className="pj-checkout-plan-name">{plano.name}</div>
                                                                    <div className="pj-checkout-plan-pricing">
                                                                        {showPromotionalPrice ? (
                                                                            <>
                                                                                <div className="pj-checkout-plan-original-price">
                                                                                    {formatPriceWithSymbol(valorOriginal)}
                                                                                </div>
                                                                                <div className="pj-checkout-plan-promo">
                                                                                    {formatPriceWithSymbol(plano.promotional_price || 19.90)}
                                                                                </div>
                                                                                <div className="pj-checkout-plan-promo-label">
                                                                                    {t('plans.promotionalFirst6Months')}
                                                                                </div>
                                                                                <div className="pj-checkout-plan-after">
                                                                                    {t('plans.afterPrice', { price: formatPriceWithSymbol(valorOriginal) })}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <div className="pj-checkout-plan-main-price">
                                                                                {formatPriceWithSymbol(plano.plan_cycle === "YEARLY" ? valorOriginal / 12 : valorOriginal)}
                                                                                <span>
                                                                                    {plano.plan_cycle === "WEEKLY" && t('plans.perWeek')}
                                                                                    {plano.plan_cycle === "MONTHLY" && t('plans.perMonth')}
                                                                                    {plano.plan_cycle === "YEARLY" && t('plans.perMonth')}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {isActive ? (
                                                                        <div className="pj-checkout-plan-selected-label">
                                                                            <FaCheckCircle size={14} /> {t('plans.selected', { defaultValue: 'Selecionado' })}
                                                                        </div>
                                                                    ) : (
                                                                        <button
                                                                            className="pj-checkout-plan-cta"
                                                                            onClick={(e) => { e.stopPropagation(); handleChoosePlan(plano.plan_identifier, plano.plan_cycle, plano.valor_plano, showPromotionalPrice); }}
                                                                        >
                                                                            {t('plans.subscribe')}
                                                                        </button>
                                                                    )}
                                                                </PjCheckoutPlanCard>
                                                            );
                                                        })
                                                        :
                                                        <LoadingContainer>
                                                            <div className="spinner-wrapper">
                                                                <div className="spinner-ring"></div>
                                                                <div className="spinner-ring-inner"></div>
                                                                <FaCrown className="spinner-icon" />
                                                            </div>
                                                            <span className="loading-text">{t('loading')}</span>
                                                        </LoadingContainer>
                                                }
                                            </PjCheckoutPlansGrid>
                                        </PjCheckoutWrapper>
                                }

                                {
                                    plan_cycle === "" ?
                                        <></>
                                        :
                                        <PjCheckoutPaymentSection>
                                            <PjCheckoutNotice>
                                                <RiErrorWarningLine /> {t('paymentMethods.billingDateNotice', { day: currentDay })}
                                            </PjCheckoutNotice>

                                            <PjCheckoutPaymentMethods>
                                                <div className="pj-checkout-payment-title">{t('paymentMethods.chooseMethod')}</div>
                                                <div className="pj-checkout-payment-options">
                                                    <PjCheckoutPaymentOption $active={payment_type === "CREDIT_CARD"} onClick={() => handlePaymentType("CREDIT_CARD")}>
                                                        <div className="pj-checkout-payment-option-left">
                                                            <div className="pj-checkout-payment-radio" />
                                                            <span>{t('paymentMethods.creditCard')}</span>
                                                        </div>
                                                        <IoIosCard className="pj-checkout-payment-option-icon" />
                                                    </PjCheckoutPaymentOption>

                                                    <PjCheckoutPaymentOption $active={payment_type === "BOLETO"} onClick={() => handlePaymentType("BOLETO")}>
                                                        <div className="pj-checkout-payment-option-left">
                                                            <div className="pj-checkout-payment-radio" />
                                                            <span>{t('paymentMethods.boleto')}</span>
                                                        </div>
                                                        <FaBarcode className="pj-checkout-payment-option-icon" />
                                                    </PjCheckoutPaymentOption>

                                                    <PjCheckoutPaymentOption $active={payment_type === "PIX"} onClick={() => handlePaymentType("PIX")}>
                                                        <div className="pj-checkout-payment-option-left">
                                                            <div className="pj-checkout-payment-radio" />
                                                            <span>{t('paymentMethods.pix')}</span>
                                                        </div>
                                                        <MdPix className="pj-checkout-payment-option-icon" />
                                                    </PjCheckoutPaymentOption>
                                                </div>
                                            </PjCheckoutPaymentMethods>

                                            <PjCheckoutForm>
                                                <form onSubmit={formik.handleSubmit}>
                                                    <button
                                                        type="button"
                                                        disabled={loadingCustomerData}
                                                        className="pj-checkout-autofill-btn"
                                                        onClick={handleGetDataCustomer}
                                                    >
                                                        {loadingCustomerData ? <Loading type="spin" color="white" height={18} width={18} /> : null}
                                                        {t('form.useRegisteredData')}
                                                    </button>

                                                    <div className="pj-checkout-person-type">
                                                        <div className="pj-checkout-person-label">{t('form.choosePersonType')}</div>
                                                        <div className="pj-checkout-person-options">
                                                            <PjCheckoutPersonOption $active={person_type === "cnpj"} onClick={() => handlePersonType("cnpj")}>
                                                                <div className="pj-checkout-person-radio" />
                                                                <div className="pj-checkout-person-info">
                                                                    <div className="pj-checkout-person-title">{t('form.cnpj')}</div>
                                                                    <div className="pj-checkout-person-desc">{t('form.legalEntity')}</div>
                                                                </div>
                                                            </PjCheckoutPersonOption>
                                                            <PjCheckoutPersonOption $active={person_type === "cpf"} onClick={() => handlePersonType("cpf")}>
                                                                <div className="pj-checkout-person-radio" />
                                                                <div className="pj-checkout-person-info">
                                                                    <div className="pj-checkout-person-title">{t('form.cpf')}</div>
                                                                    <div className="pj-checkout-person-desc">{t('form.individual')}</div>
                                                                </div>
                                                            </PjCheckoutPersonOption>
                                                        </div>
                                                    </div>

                                                    <div className="pj-checkout-form-grid two-cols">
                                                        <div className="pj-checkout-field">
                                                            <label>{person_type === "cnpj" ? t('form.cnpj') : t('form.cpf')}<span className="pj-checkout-required">*</span></label>
                                                            <InputMask
                                                                placeholder={person_type === "cnpj" ? t('form.enterCnpj') : t('form.enterCpf')}
                                                                id="cpf_cnpj"
                                                                name="cpf_cnpj"
                                                                mask={person_type === "cnpj" ? "99.999.999/9999-99" : "999.999.999-99"}
                                                                onChange={formik.handleChange}
                                                                value={formik.values.cpf_cnpj}
                                                            />
                                                            {formik.errors.cpf_cnpj && <div className="pj-checkout-field-error">{formik.errors.cpf_cnpj}</div>}
                                                        </div>
                                                        <div className="pj-checkout-field">
                                                            <label>{person_type === "cnpj" ? t('form.companyName') : t('form.name')}<span className="pj-checkout-required">*</span></label>
                                                            <input
                                                                placeholder={person_type === "cnpj" ? t('form.enterCompanyName') : t('form.enterName')}
                                                                id="nomeOrRazao"
                                                                name="nomeOrRazao"
                                                                onChange={formik.handleChange}
                                                                value={formik.values.nomeOrRazao}
                                                            />
                                                            {formik.errors.nomeOrRazao && <div className="pj-checkout-field-error">{formik.errors.nomeOrRazao}</div>}
                                                        </div>
                                                    </div>

                                                    <div className="pj-checkout-form-grid three-cols">
                                                        <div className="pj-checkout-field">
                                                            <label>{t('form.email')}<span className="pj-checkout-required">*</span></label>
                                                            <InputMask
                                                                placeholder={t('form.enterEmail')}
                                                                id="email"
                                                                type="email"
                                                                name="email"
                                                                onChange={formik.handleChange}
                                                                value={formik.values.email}
                                                            />
                                                            {formik.errors.email && <div className="pj-checkout-field-error">{formik.errors.email}</div>}
                                                        </div>
                                                        <div className="pj-checkout-field">
                                                            <label>{t('form.zipCode')}<span className="pj-checkout-required">*</span></label>
                                                            <InputMask
                                                                placeholder={t('form.enterZipCode')}
                                                                id="cep"
                                                                name="cep"
                                                                mask={"99999-999"}
                                                                onChange={formik.handleChange}
                                                                value={formik.values.cep}
                                                            />
                                                            {formik.errors.cep && <div className="pj-checkout-field-error">{formik.errors.cep}</div>}
                                                        </div>
                                                        <div className="pj-checkout-field">
                                                            <label>{t('form.number')}<span className="pj-checkout-required">*</span></label>
                                                            <input
                                                                placeholder={t('form.enterNumber')}
                                                                id="numero"
                                                                name="numero"
                                                                onChange={formik.handleChange}
                                                                value={formik.values.numero}
                                                            />
                                                            {formik.errors.numero && <div className="pj-checkout-field-error">{formik.errors.numero}</div>}
                                                        </div>
                                                    </div>
                                                </form>
                                            </PjCheckoutForm>

                                            <PjCheckoutFooter>
                                                <div className="pj-checkout-total">
                                                    {t('form.totalToPay')} <strong>{formatPriceWithSymbol(priceToPay)}</strong>
                                                </div>
                                                <PjCheckoutSubmitBtn
                                                    type="button"
                                                    disabled={isFinalizando}
                                                    onClick={formik.handleSubmit}
                                                >
                                                    {isFinalizando
                                                        ? <Loading type='spin' color='white' height={22} width={22} />
                                                        : t('form.finishPayment')
                                                    }
                                                </PjCheckoutSubmitBtn>
                                            </PjCheckoutFooter>
                                        </PjCheckoutPaymentSection>
                                }

                                <PjCheckoutFeatures>
                                    <div className="pj-checkout-features-title">{t('features.title')}</div>
                                    <div className="pj-checkout-features-grid">
                                        <div className="pj-checkout-feature-tag">{t('features.whatsappAssistant')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.cashierModule')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.waiterMode')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.tableQRCode')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.installationService')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.deliveryRegistration')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.ordersPanel')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.onlineSupport')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.digitalMenu')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.pointOfSale')}</div>
                                        <div className="pj-checkout-feature-tag">{t('features.salesReports')}</div>
                                    </div>
                                </PjCheckoutFeatures>
                                {/*invoiceData &&
                                    <div className="footerBtnPlanos">
                                        <button type="button" onClick={handleSeePlans}>{seeAllPlans ? "Verificar Faturas" : "Verificar Planos"}</button>
                                    </div>
                                */}
                            </div>

                        </div>
                    
                </div>
            </Teste>
        </div>
    );
}

export default Planos; 